// src/app/services/arresting-agency.service.ts
import { Injectable } from '@angular/core';
import { InstanceService } from '@tylertech/cj-inmate-search-angular-sdk';
import { Observable, catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ArrestingAgencyService {
  constructor(private _instanceService: InstanceService) {}

  getArrestingAgencies(instanceId: string): Observable<string[]> {
    return this._instanceService.getArrestingAgencies(instanceId).pipe(
      catchError(error => {
        console.error('Error fetching arresting agencies:', error);
        return of([]);
      })
    );
  }
}